/** Iniciais da primeira e última palavra, ou os dois primeiros caracteres de uma palavra única. */
export function calcularIniciais(texto: string | null | undefined): string {
  const nome = texto?.trim();
  if (!nome) return '';
  const palavras = nome.split(/\s+/);
  const primeira = Array.from(palavras[0]);
  const iniciais = palavras.length === 1
    ? primeira.slice(0, 2).join('')
    : primeira[0] + Array.from(palavras[palavras.length - 1])[0];
  return iniciais.toLocaleUpperCase('pt-BR');
}

export class Utils {

  public static isValidEmail(email: string | null | undefined): boolean {
    if (!email) return false;
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim().toLowerCase());
  }

  public static formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleString('pt-BR', {
      day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
    }).replace(',', '');
  }

  public static getCurrentDateForFilename(): string {
    const now = new Date();
    const p = (n: number) => String(n).padStart(2, '0');
    return `${now.getFullYear()}${p(now.getMonth() + 1)}${p(now.getDate())}_${p(now.getHours())}${p(now.getMinutes())}`;
  }
}
